export const NEW_RESPONSIBLE_CPF_MESSAGES = {
  LABEL: "CPF do Novo Responsável (opcional):",
  PLACEHOLDER: "000.000.000-00",
  INVALID: "CPF inválido",
} as const;
